<template>
  <div class="support-with-search">
    <LsTopLevelSearchInput
      v-model="searchInput"
      track-id="support_search-search"
      @input="onChange"
    />
    <NoSearchResultsFound v-if="!hasResults" />
    <div v-else-if="showCategories">
      <div v-for="(actionsList, category) in allActionsByCategory" :key="category">
        <div class="columns is-multiline">
          <div class="column is-full">
            <h2>{{ category }}</h2>
          </div>
          <div v-for="action in cleanList(actionsList)" :key="action" class="column is-one-third">
            <LsButton
              :test-id="getActionProperty(action, 'action')"
              :text="getActionDisplayTranslated(action)"
              :is-uppercase="false"
              class="is-inline-block is-fullwidth"
              :track-id="getActionProperty(action, 'action')"
              variant-override="primary-outlined"
              @click="onClick($event, action)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="search-results columns is-multiline">
      <div v-for="action in filteredActions" :key="action.action" class="column is-one-third">
        <LsButton
          :test-id="action.action"
          :text="action.display"
          :is-uppercase="false"
          class="is-inline-block is-fullwidth"
          :track-id="action.action"
          variant-override="primary-outlined"
          @click="onClick($event, action.action)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsModalService, lsI18NService, lsErrorService } from 'ls-vue-common';
import { ChangeFrequencyModal, DisputeMowModal } from '@/modals';
import { SUPPORT__MUTATE_SEARCH_QUERY } from '@/store/types';
import {
  getLookupByActionName,
  openTrustFee,
  openLongGrassFee,
  openThreeCutMin,
} from '@/store/modules/support/support.helpers';
import { LsButton } from '@/components/common';
import { LsTopLevelSearchInput } from '@/components';
import { mapMutations } from 'vuex';
import NoSearchResultsFound from '../NoSearchResultsFound/NoSearchResultsFound.vue';

export default {
  name: 'SupportWithSearch',
  components: {
    LsTopLevelSearchInput,
    NoSearchResultsFound,
    LsButton,
  },
  props: {
    allActions: VueTypes.array.isRequired,
    filteredActions: VueTypes.array.isRequired,
    showCategories: VueTypes.bool.isRequired,
    allActionsByCategory: VueTypes.object.isRequired,
  },
  data() {
    return {
      searchInput: '',
    };
  },
  computed: {
    lookupByActionName() {
      return getLookupByActionName(this.allActions);
    },
    allActionsForLookup() {
      const actions = new Set();

      _.forEach(this.allActions, ({ action }) => {
        actions.add(action);
      });

      return actions;
    },
    hasResults() {
      return !!(this.filteredActions.length || this.showCategories);
    },
  },
  methods: {
    ...mapMutations([SUPPORT__MUTATE_SEARCH_QUERY]),
    onChange(value) {
      this[SUPPORT__MUTATE_SEARCH_QUERY](value);
    },
    getActionProperty(actionName, propertyName) {
      return _.get(this, `lookupByActionName[${actionName}][${propertyName}]`, '');
    },
    getActionDisplayTranslated(actionName) {
      const translateKey = _.get(this, `lookupByActionName[${actionName}][translateKey]`);
      return translateKey
        ? lsI18NService.translate(translateKey)
        : _.get(this, `lookupByActionName[${actionName}][display]`);
    },
    openPayment() {
      const name = 'profileUpdatePayment';
      this.$router.push({ name });
    },
    changeFrequency() {
      lsModalService.open({
        parent: this,
        component: ChangeFrequencyModal,
      });
    },
    disputeMow() {
      lsModalService.open({
        parent: this,
        component: DisputeMowModal,
      });
    },
    openTrustFee() {
      openTrustFee();
    },
    openLongGrassFee() {
      openLongGrassFee();
    },
    openThreeCutMin() {
      openThreeCutMin();
    },
    cancelSubscription() {
      this.$router.push({
        name: 'selectCancelService',
      });
    },
    onClick(event, actionName) {
      const { method, route } = this.lookupByActionName[actionName] || {};

      if (method) {
        this[method]();
      } else if (route) {
        this.$router.push({ name: route });
      } else {
        lsErrorService.log(`No method or route was associated with the action ${actionName}`);
      }
    },
    cleanList(actionsList) {
      return _.filter(actionsList, (action) => {
        return this.allActionsForLookup.has(action);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.support-with-search {
  .column div:not(:last-child) {
    margin-bottom: 38px;
  }
  .search-results {
    margin-top: 50px;
  }
  h2 {
    margin-top: 50px;
    font-weight: 700;
  }
}
</style>
